/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Brand = {
    BeamscanBrand: 'BEAMSCANBrand',
    MicroDiamondBrand: 'MicroDiamondBrand',
    NomexBrand: 'NOMEXBrand',
    OctaviusBrand: 'OCTAVIUSBrand',
    RubyBrand: 'RUBYBrand',
    TrufixBrand: 'TRUFIXBrand',
    UnicheckBrand: 'UNICHECKBrand',
    UnidosBrand: 'UNIDOSBrand',
    StarcheckBrand: 'STARCHECKBrand',
    CouchfixBrand: 'COUCHFIXBrand'
} as const;
export type Brand = typeof Brand[keyof typeof Brand];


export function BrandFromJSON(json: any): Brand {
    return BrandFromJSONTyped(json, false);
}

export function BrandFromJSONTyped(json: any, ignoreDiscriminator: boolean): Brand {
    return json as Brand;
}

export function BrandToJSON(value?: Brand | null): any {
    return value as any;
}

/**
 * Check if a given object implements the Brand interface.
 */
 export function instanceOfBrand(value: any): value is Brand {
    return Object.values(Brand).includes(value)
}

